module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/guard_shield_laser.031898e1.png";